(() => {
  function init() {
    const triggers=()=>[...document.querySelectorAll('[data-ak-price-request-trigger]')];
    const trigger=triggers()[0];
    const panel=document.querySelector('[data-ak-price-request-panel]');
    if (!trigger || !panel || trigger.dataset.akRequestMounted) return;
    trigger.dataset.akRequestMounted='true';
    const root=trigger.closest('[data-ak-price-on-request],[data-ak-art-product]');
    document.body.append(panel);
    let open=false,hideTimer=0,frame=0;
    function place() {
      frame=0;
      const visibleTrigger=triggers().find(element=>element.getBoundingClientRect().width>0) || trigger;
      // Mobile opens above the full size/status row, not above its CTA cell.
      const mobile=matchMedia('(max-width:1200px)').matches;
      const anchor=mobile && root.hasAttribute('data-ak-art-product')
        ? root.querySelector('[data-ak-mobile-controls]') : visibleTrigger;
      const button=(anchor || visibleTrigger).getBoundingClientRect();
      const left=Math.max(0,button.left);
      panel.style.setProperty('--ak-request-left',`${left}px`);
      panel.style.setProperty('--ak-request-width',`${Math.min(innerWidth-left,button.right-left)}px`);
      panel.style.setProperty('--ak-request-bottom',`${innerHeight-button.top}px`);
      document.body.style.setProperty('--ak-request-badge-right',`${Math.max(12,innerWidth-button.right)}px`);
      document.body.style.setProperty('--ak-request-badge-bottom',`${innerHeight-button.top+(open?panel.offsetHeight:0)+8}px`);
    }
    function schedule() {if(open&&!frame)frame=requestAnimationFrame(place);}
    function setOpen(value,focus=false) {
      clearTimeout(hideTimer);
      open=value;
      triggers().forEach(element=>element.setAttribute('aria-expanded',String(value)));
      if(value){
        panel.hidden=false;
        place();
        void panel.offsetHeight;
        panel.classList.add('is-open');
        if(focus)panel.querySelector('input:not([type="hidden"])')?.focus({preventScroll:true});
      }else{
        panel.classList.remove('is-open');
        place();
        hideTimer=setTimeout(()=>{if(!open)panel.hidden=true;},400);
      }
    }
    // The mobile purchase bar replaces its controls during setup. Delegate
    // so rebuilt buttons keep the same request form behaviour.
    document.addEventListener('click',event=>{
      if(event.target.closest('[data-ak-price-request-trigger]'))setOpen(!open,true);
    },true);
    document.addEventListener('pointerdown',event=>{if(open&&!panel.contains(event.target)&&!triggers().some(element=>element.contains(event.target)))setOpen(false);});
    document.addEventListener('keydown',event=>{if(open&&event.key==='Escape'){setOpen(false);(triggers().find(element=>element.getBoundingClientRect().width>0)||trigger).focus({preventScroll:true});}});
    window.addEventListener('resize',schedule,{passive:true});
    window.addEventListener('scroll',schedule,{passive:true});
    document.getElementById('MainContent')?.addEventListener('scroll',schedule,{passive:true});
    window.visualViewport?.addEventListener('resize',schedule,{passive:true});
    window.addEventListener('ak:browser-resume',schedule);
    const observer=new ResizeObserver(schedule);
    triggers().forEach(element=>observer.observe(element));
    root.addEventListener('animationend',schedule,true);
    panel.querySelector('form')?.addEventListener('submit',()=>{
      const form=panel.querySelector('form');
      const data=new FormData(form);
      form.querySelector('[name="contact[body]"]').value=`PRICE REQUEST\nProduct: ${data.get('contact[Product]')}\nLink: ${data.get('contact[Product URL]')}\nName: ${data.get('contact[name]')}\nTelephone: ${data.get('contact[phone]')}\nMail: ${data.get('contact[email]')}`;
    });
    if(panel.querySelector('[data-ak-price-request-success],.ak-price-request-errors'))setOpen(true);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();
